import $ from "jquery";

const INITIAL_MINUTES_BETWEEN_REMINDERS = 10;
const SUBSEQUENT_MINUTES_BETWEEN_REMINDERS = 15;
let upsellTime;

export const reset = (overrideMinutes?) => {
  const minutes = overrideMinutes || SUBSEQUENT_MINUTES_BETWEEN_REMINDERS;
  upsellTime = new Date(new Date().getTime() + minutes * 60 * 1000);
};
export const isReady = () => new Date() > upsellTime;

reset(INITIAL_MINUTES_BETWEEN_REMINDERS);

$(window).focus(() => {
  reset(INITIAL_MINUTES_BETWEEN_REMINDERS);
});
